export default {
  resource: 'constants',
  actions: ['index']
}
